// extracted by mini-css-extract-plugin
var _1 = "KQzS2";
export { _1 as "base" }
